/** SellerClub seller support (onboarding / account help) */
export const SELLERCLUB_SUPPORT_PHONE = '9187509609';
export const SELLERCLUB_SUPPORT_PHONE_DISPLAY = '+91 91875 09609';
